// =====================================================
// SCHEMAS: EMAIL TEMPLATE
// Description: Schémas Zod pour les modèles d'email (item #7 retours client)
// =====================================================

import { z } from 'zod';

export const emailTemplateSchema = z.object({
  name: z.string().min(1, 'Le nom est requis').max(200, 'Le nom est trop long'),
  subject: z.string().min(1, 'Le sujet est requis').max(500, 'Le sujet est trop long'),
  body: z.string().min(1, 'Le corps est requis'),
  entity_scope: z.enum(['all', 'crew', 'contact']),
});

export type EmailTemplateInput = z.infer<typeof emailTemplateSchema>;
